import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

class BreadCrumb extends React.Component {
  render() {
    const { routes } = this.props;
    return (
      <div className="breadCrumb">
        {routes?.map((path, index) => (
          <>
            <Link
              className="breadCrumbItem"
              key={index}
              to={path.link}
            >
              {path.name}
            </Link>
            {index !== routes.length - 1 ? <span> / </span> : null}
          </>
        ))}
      </div>
    );
  }
}
BreadCrumb.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export default BreadCrumb;
